module.exports = __webpack_public_path__ + "img/14b4e47aad4988246ed05ecd1c9b22c7.81982e37.png";